import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["theme"],
    _excluded2 = ["theme", "breadcrumbs", "buttons", "header", "subtitle", "breadcrumbsProps", "buttonsProps", "headerProps", "subtitleProps", "breakpoint", "children"];
import React from 'react';
import styled, { withTheme } from 'styled-components';
import { px } from 'styled-system';
import Box from '../Box';
import Text from '../Text';
import { withBreakpoint } from '../BreakpointContext';
var Container = styled(Box).withConfig({
  displayName: "DrillIn__Container",
  componentId: "sc-3wmw1a-0"
})(["border-bottom:", ";"], function (_ref) {
  var theme = _ref.theme;
  return "1px solid ".concat(theme.colors.keyline);
});
var DrillInContent = withTheme(function (_ref2) {
  var theme = _ref2.theme,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(Box, _extends({
    marginLeft: ['auto', px(theme.responsiveASC.md.paddingX), px(theme.responsiveASC.lg.paddingX), 'auto'],
    marginRight: ['auto', px(theme.responsiveASC.md.paddingX), px(theme.responsiveASC.lg.paddingX), 'auto'],
    width: ['auto', 'auto', 'auto', px(theme.responsiveASC.xl.contentWidth)],
    maxWidth: ['auto', 'auto', 'auto', '100%']
  }, props));
});

var isSmallViewport = function isSmallViewport(_ref3) {
  var bpName = _ref3.bpName;
  return bpName === 'sm';
};

var DrillIn = withTheme(withBreakpoint(function (_ref4) {
  var theme = _ref4.theme,
      breadcrumbs = _ref4.breadcrumbs,
      buttons = _ref4.buttons,
      header = _ref4.header,
      subtitle = _ref4.subtitle,
      _ref4$breadcrumbsProp = _ref4.breadcrumbsProps,
      breadcrumbsProps = _ref4$breadcrumbsProp === void 0 ? {} : _ref4$breadcrumbsProp,
      _ref4$buttonsProps = _ref4.buttonsProps,
      buttonsProps = _ref4$buttonsProps === void 0 ? {} : _ref4$buttonsProps,
      _ref4$headerProps = _ref4.headerProps,
      headerProps = _ref4$headerProps === void 0 ? {} : _ref4$headerProps,
      _ref4$subtitleProps = _ref4.subtitleProps,
      subtitleProps = _ref4$subtitleProps === void 0 ? {} : _ref4$subtitleProps,
      breakpoint = _ref4.breakpoint,
      children = _ref4.children,
      props = _objectWithoutProperties(_ref4, _excluded2);

  var drillInTheme = theme.drillIn;
  return /*#__PURE__*/React.createElement(DrillInContent, null, /*#__PURE__*/React.createElement(Container, _extends({}, drillInTheme.offset, props), breadcrumbs && /*#__PURE__*/React.createElement(Box, _extends({}, drillInTheme.breadcrumbs.spacings, breadcrumbsProps), /*#__PURE__*/React.cloneElement(breadcrumbs)), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between"
  }, header && /*#__PURE__*/React.createElement(Text, _extends({
    as: "h2",
    textStyle: "h2Emph"
  }, drillInTheme.header.spacings, headerProps), header), !isSmallViewport(breakpoint) && buttons && /*#__PURE__*/React.createElement(Box, _extends({
    flexShrink: 0
  }, buttonsProps), buttons)), subtitle && /*#__PURE__*/React.createElement(Text, _extends({}, drillInTheme.subtitle.spacings, subtitleProps), subtitle), isSmallViewport(breakpoint) && buttons && /*#__PURE__*/React.createElement(Box, _extends({
    flexShrink: 0
  }, drillInTheme.buttons.spacings, buttonsProps), buttons)), children);
}));
var DrillInButtons = withTheme(function (_ref5) {
  var theme = _ref5.theme,
      children = _ref5.children;
  var buttonTheme = theme.drillIn.buttons.button;
  var count = React.Children.count(children);
  return /*#__PURE__*/React.createElement(React.Fragment, null, React.Children.map(children, function (button, index) {
    return /*#__PURE__*/React.cloneElement(button, {
      mb: buttonTheme.offset.bottom,
      mr: index + 1 === count ? 0 : buttonTheme.offset.right
    });
  }));
});
DrillIn.Buttons = DrillInButtons;
export default DrillIn;